<template>
	<div class="wrap classify-wrap flex-column">
		<topLink></topLink>
		<!-- 搜索框 -->
		<div class="input-box">
			<input @click="searchgoods" class="serarch-input" type="text" name="" placeholder="搜索商品" v-model="keyWord">
		</div>
		<mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load"/>
		<div class="flex-item tab-content" v-else>
			<!-- 菜单栏 -->
			<div class="tab-bar" ref="tabBar">
				<div @click="tabIndex = 'essence';isTabIndex = false" class="tab-item verticalM" :class="{active:tabIndex=='essence'}">
					<span class="verticalM-box">为您推荐</span>
				</div>
				<div @click="selTab(index)" class="tab-item verticalM" :class="{active:tabIndex==index}" v-for="(brandItem,index) in brandCates">
					<span class="verticalM-box">{{brandItem.cates.linkName}}</span>
				</div>
			</div>
			<div class="brand-content" ref="brandContent">
				<div class="logo" v-if="tabIndex!='essence'">
					<div class="img-box">
						<imgs :imagePath="brandCates[tabIndex] && brandCates[tabIndex].cates.imagePath.imagePath"></imgs>
					</div>
				</div>
				<div class="recommend-content" v-if="tabIndex=='essence'">
					<div class="banner" v-if="adverstore" @click="linkFn(adverstore.linkType,adverstore.linkTarget)">
						<imgs :width="500" :imagePath="adverstore && adverstore.imagePath && adverstore.imagePath.imagePath"></imgs>
					</div>
					<div class="header">
						<span>精品推荐</span>
					</div>
					<div class="product-item square" v-for="(item,index) in boutiques" @click="scanDetail(item.storeId,item.goodsId,item.skuId)">
						<imgs :width="270" :height="270" :imagePath="item.imagePath && item.imagePath.imagePath" :titleText="item.goodsName"></imgs>
					</div>
				</div>
				<div class="product-content" v-if="tabIndex!='essence'">
					<div class="banner" v-if="adverbrand" @click="linkFn(adverbrand.linkType,adverbrand.linkTarget)">
						<imgs :width="500" :imagePath="adverbrand && adverbrand.imagePath && adverbrand.imagePath.imagePath"></imgs>
					</div>
					<div class="product-item square" v-for="(goodItem,goodIndex) in (brandCates[tabIndex] && brandCates[tabIndex].goodsList)" @click="scanDetail(brandCates[tabIndex].cates.linkTarget,goodItem.goodsId,goodItem.skuId)">
						<imgs :width="270" :height="270" :imagePath="goodItem && goodItem.imagePath && goodItem.imagePath.imagePath" :titleText="goodItem.goodsName"></imgs>
					</div>
				</div>
			</div>
		</div>
		<menus></menus>
	</div>
</template>
<script type="text/javascript">
	import menus from '@components/menus/menus';
	import topLink from '@components/topLink/topLink';
	import imgs from '@components/image/image';
	import {mapActions,mapGetters} from 'vuex';
	export default{
		data () {
			return {
				load:true,
				tabIndex: 'essence',//左侧选中，默认精品
				brandCates:[],//品牌分类
				keyWord:'',
				adverbrand:{},//随机品牌广告
				adverstore:{},//随机商城广告
				boutiques: [], //精品推荐
				isTabIndex:true
			}
		},
		updated () {
		    if(this.isTabIndex && (this.$route.meta.tabIndex >= 0 || this.$route.meta.tabIndex == "essence")){
		    	console.log(this.$route.meta.tabIndex)
			    this.$nextTick(function(){
				    this.tabIndex = this.$route.meta.tabIndex || "essence";
				    setTimeout(() => {
				        this.$route.meta.tabIndex = -1;
				    },500)
			    }) 
		    }
		    if(!this.$route.meta.savePosition){
		      	return;
		    }
		    this.$nextTick(function(){
		    	// alert(this.tabIndex)
			    this.$refs.brandContent.scrollTop = this.$route.meta.savePosition;
			    setTimeout(() => {
			        this.$route.meta.savePosition = 0;
			        this.$route.meta.tabIndex = "";
			    },500)
		    }) 
	  	},
		created(){
			this.getBrand();
			this.getGroomGoods();
			this.randomAdver([1,4]).then(res => {
		        this.adverstore = res[0];
		    })
		},
		methods: {
			...mapActions({
				getBrandCates:'getBrandCates',
				randomStoreAdverts:'randomStoreAdverts',//获取随机广告
				getBoutiqueGoods: 'getBoutiqueGoods',
				randomAdver:'randomAdver',//24.1.随便获取商城N条广告
			}),
			selTab(index){
				this.tabIndex = index;
				this.isTabIndex = false;
				let storeId = this.brandCates[this.tabIndex].cates.linkTarget
				this.randomStoreAdverts([storeId,1,4]).then(res=>{console.log(res)
					this.adverbrand = res[0]
				})
			},
			//8.3.获取首页品牌分类
			getBrand(){
				this.getBrandCates([1]).then(res=>{
					this.brandCates = res;
					console.log("ceshi")
					//this.load = false;
				})
			},
			//获取为您未见商品
			getGroomGoods(){
				 //  6.精品推荐
			      this.getBoutiqueGoods().then(res => {
			        this.boutiques = res;
			        this.load = false;
			      });
			},
			searchgoods(){
				if(this.tabIndex!='essence'){
					this.$router.push({
						path: '/main/search?linkTarget=' + this.brandCates[this.tabIndex].cates.linkTarget + '&linkType=' + this.brandCates[this.tabIndex].cates.linkType +'&keyWord=' + this.keyWord || null
					})
				}else{
					this.$router.push({
						path: '/main/search?keyWord=' + this.keyWord || null
					})
				}
				
			},
			scanDetail(storeid,goodid,skuId){
				this.$route.meta.savePosition = this.$refs.brandContent.scrollTop;
				this.$route.meta.tabIndex = this.tabIndex;
				this.$router.push({
					path: '/main/goodsDetail?goodsId='+ goodid +'&storeId=' + storeid +'&skuId=' + skuId
				})
			}
		},
		components:{
			menus,
			topLink,
			imgs
		}
	}
</script>
<style lang="scss" rel="stylesheet/scss">
	@import 'src/common/sass/mixin.scss';
	.classify-wrap{
		.input-box{
			width: 100%;
			padding: 0.1rem 0;
			background: #fff;
			box-shadow: 0 1px 2px 0 rgba(0,0,0,0.09);
			z-index: 2;
			.serarch-input{
				display: block;
				width: 93%;
				height: 0.7rem;
				margin: 0 auto;
				border-radius: 0.675rem;
				@include sInput(#EFEFEF,center,#999999);
				background: url(/static/images/productList_search@3x.png) no-repeat 0.25rem center;
				background-size: 0.45rem;
				background-color: #EFEFEF;
			}
		}
		.tab-content{
			height: 100%;
			background: #fff;
			position: relative;
			/* .flex-row{
				height: 100%; */
				.tab-bar{
					width:2.25rem;
					height: 100%;
					border-right: 1px solid #E0E0E0;
					-webkit-overflow-scrolling: touch;
					overflow: auto;
					position: absolute;
					left: 0;
					.tab-item{
						border-left: 0.075rem solid #fff;
						text-align: center;
						height: 1.25rem;
						@include font-dpr(13px);
						color: #4A4A4A;
						border-bottom: 1px solid #E0E0E0;
						&.active{
							border-left-color: #E60012;
							color: #E60012;
						}
					}
				}
				.brand-content{
					height: 100%;
					position: absolute;
					left: 2.25rem;
					right: 0;
					-webkit-overflow-scrolling: touch;
					overflow: auto;
					.logo{
						padding: 0.5rem;
						.img-box{
							width: 3.35rem;
							margin: 0 auto;
						}
					}
					.banner{
						width: 96%;
						height: auto;
						margin: 0.15rem auto 0.15rem auto;
						border-radius: 0.125rem;
						overflow: hidden;
					}
					.recommend-content{
						.header{
							overflow: hidden;
							text-align: center;
							margin-top: 0.35rem;
							margin-bottom: 0.5rem;
							>span{
								color: #333333;
								@include font-dpr(14px);
								padding: 0 1.25rem;
								position: relative;
								&:before,&:after{
									content: "";
									display: inline-block;
									width: 1.0rem;
									height: 0.05rem;
									position: absolute;
									top: 50%;
									background: #C0C0C0;
								}
								&:before{
									left: 0;
								}
								&:after{
									right: 0;
								}
							}
						}
					}
					.recommend-content,.product-content{
						font-size: 0;
						.product-item{
							display: inline-block;
							width: 33%;
							vertical-align: top;
							max-width: 7.5rem;
							margin-bottom: 0.25rem;
							@include font-dpr(12px);
							.title{
								color: #666666;
								margin: 0.2rem 0.075rem 0.15rem 0.075rem;
							}
						}
					}
				}
			/* } */
		}
	}
</style>


// WEBPACK FOOTER //
// classify.vue?82dd4fda